'use client'

import { AreaItem } from '@/types/cms/AreaItem'
import styles from '@/elements/widgets/Teaser/Infinity/TeaserInfinity.module.scss'
import { Link } from '@/components/Link'
import { Image } from '@/components/Image'
import React, { useEffect } from 'react'
import SectionTitle from '@/components/SectionTitle/SectionTitle'
import Button from '@/components/Button/Button'
import { clsx } from 'clsx'
import TypeVisualizer from '@/elements/widgets/Teaser/components/TypeVisualizer/TypeVisualizer'
import LiveLabel from '@/elements/widgets/Teaser/components/LiveLabel/LiveLabel'

type TeaserInfinityProps = {
  item: AreaItem
  displayCountMobile?: number
  displayCount?: number
  loadCountMobile?: number
  loadCount?: number
}

const TeaserInfinity = ({
  item,
  displayCountMobile = 4,
  displayCount = 6,
  loadCountMobile = 4,
  loadCount = 6,
}: TeaserInfinityProps) => {
  const [grid, setGrid] = React.useState<string | undefined>(undefined)
  const [loadedItems, setLoadedItems] = React.useState(0)

  const showMoreItems = () => {
    if (['xs', 's'].includes(grid as string)) {
      setLoadedItems((prev) => prev + loadCountMobile)
    } else {
      setLoadedItems((prev) => prev + loadCount)
    }
  }

  const displayedItems = (['xs', 's'].includes(grid as string) ? displayCountMobile : displayCount) + loadedItems

  useEffect(() => {
    const element = document.documentElement

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry.contentRect.width <= 743) {
        setGrid('xs')
      } else if (entry.contentRect.width <= 903) {
        setGrid('s')
      } else if (entry.contentRect.width <= 1235) {
        setGrid('m')
      } else if (entry.contentRect.width <= 1375) {
        setGrid('l')
      } else if (entry.contentRect.width <= 1799) {
        setGrid('xl')
      } else {
        setGrid('xxl')
      }
    })

    observer.observe(element)

    return () => observer.disconnect()
  }, [])

  return (
    <section className={styles.section}>
      {item.model?.fields?.headline && (
        <SectionTitle title={item.model?.fields?.headline} link={item.model?.fields?.link as any} />
      )}
      <div className={styles['teaser-container']}>
        {item.items?.map((teaser, index) => {
          return (
            <article
              key={index}
              className={clsx(
                styles.teaser,
                !(index < (['xs', 's'].includes(grid as string) ? displayCountMobile : displayCount) + loadedItems) &&
                  styles.hidden,
              )}
              title={teaser.model.headline ?? teaser.model.title}
            >
              <Link
                href={
                  teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
                    ? teaser.model.linkExternal?.url
                    : teaser.model.url
                }
                target={
                  teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
                    ? teaser.model.linkExternal?.target
                    : '_self'
                }
                className={styles.link}
              >
                <div className={styles.container}>
                  <Image
                    image={teaser.model.image}
                    alt={teaser.model.image?.filename || teaser.model.title}
                    className={styles.image}
                    defaultWidth={475}
                  />
                  <LiveLabel url={teaser?.model?.linkExternal?.url} position="bottom-right" />
                  <TypeVisualizer item={teaser} position="bottom-right" />
                </div>
                <div className={styles.headline}>{teaser.model.headline}</div>
                {!item?.model?.fields?.hideSection && (
                  <div className={styles['section-title']}>{teaser.model.homeSection}</div>
                )}
              </Link>
            </article>
          )
        })}
      </div>
      {(item.items?.length || 0) > displayedItems && (
        <Button onClick={() => showMoreItems()} className={styles['load-more-btn']}>
          Mehr Inhalte anzeigen
        </Button>
      )}
    </section>
  )
}

export default TeaserInfinity
